var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-item-container"},_vm._l((_vm.newsItems),function(newsItem,index){return _c('div',{key:index},[_c('news-item',{attrs:{"newsItem":newsItem}}),_vm._v(" "),_c('hr')],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6abbf4bf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Press.vue
// module id = 278
// module chunks = 0